import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGaugeChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 15,
	viewBox: "0 0 17 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.61834 13.3751C1.65928 12.271 1.03801 10.9143 0.828584 9.46686C0.619159 8.01942 0.830422 6.54228 1.43718 5.21157C2.04395 3.88086 3.02061 2.75272 4.25072 1.96166C5.48083 1.1706 6.91249 0.75 8.375 0.75C9.83752 0.75 11.2692 1.1706 12.4993 1.96166C13.7294 2.75272 14.7061 3.88086 15.3128 5.21157C15.9196 6.54228 16.1309 8.01942 15.9214 9.46686C15.712 10.9143 15.0907 12.271 14.1317 13.3751M5.2625 6.09597L8.685 8.43181C8.78026 8.49653 8.86006 8.58149 8.91869 8.6806C8.97733 8.77972 9.01337 8.89056 9.02424 9.00521C9.0351 9.11987 9.02052 9.2355 8.98155 9.34387C8.94257 9.45224 8.88015 9.55067 8.79875 9.63213C8.71735 9.7136 8.61897 9.77609 8.51063 9.81515C8.40229 9.85421 8.28666 9.86888 8.172 9.8581C8.05734 9.84732 7.94648 9.81137 7.84731 9.75281C7.74815 9.69424 7.66314 9.61451 7.59834 9.51931L5.2625 6.09597Z",
		stroke: "#18181B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgGaugeChart);
export default ForwardRef;
